import React from 'react';

import { RentalAsset } from '@kaltura-ott/tvpil-shared/lib/rhino/data/rental/types';

import { CardSkeleton } from 'components/widgets/CardView/CardSkeleton/CardSkeleton';
import { RailCardContainerProps } from 'components/widgets/Rail/components/RailProvider/types';

import RentalsCard from '../RentalsCard/RentalsCard';

function RentalsCardContainer({ item, itemWidth, imageHeight }: RailCardContainerProps<RentalAsset>) {
  if (!item?.id) {
    return <CardSkeleton height={imageHeight} width={itemWidth} />;
  }
  return <RentalsCard imageHeight={imageHeight} itemWidth={itemWidth} rentalItem={item} />;
}

export default React.memo(RentalsCardContainer);
